import { defineModel } from "../define-model";

export type Workspace = {
	id: string;
	name: string;
	slug: string;
	ownerId: string;
	planId: string;
	settings: Record<string, unknown>;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		workspace: Workspace;
	}
}

export const model = defineModel({ name: "workspace", load: "eager" });
